import * as endPoints from "../../constants/v2/endPoints";
import * as apiService from "../v2/apiService";

// `context` ({ source, threadId }) says which surface and conversation the
// message is for; the API stores it on the flag. Omitted keys are not sent,
// so first-message callers send the same body as before.
export async function checkMessageCompliance(
  text,
  tier,
  signal = null,
  context = {},
) {
  const body = { text, tier };
  if (context.source) body.source = context.source;
  if (context.threadId) body.threadId = String(context.threadId);
  return await apiService.apiCall(
    endPoints.CHECK_MESSAGE_COMPLIANCE,
    "POST",
    body,
    null,
    null,
    null,
    false,
    signal,
  );
}
